export function getReaxysSourceLabel(run = {}) {
  return run.sourceReactionId ? `Reaxys reaction RX.ID ${run.sourceReactionId}` : '';
}

export function getRetrosynthesisSourceLabel(run = {}) {
  return run.sourceProjectId && run.sourceRouteId && run.sourceStepId
    ? `Project ${run.sourceProjectId} / Route ${run.sourceRouteId} / Step ${run.sourceStepId}`
    : '';
}

export function getConditionsSourceLabel(run = {}) {
  if (run.referenceType === 'reaxys_reaction') {
    return getReaxysSourceLabel(run);
  }

  if (run.referenceType === 'retrosynthesis_step') {
    return getRetrosynthesisSourceLabel(run);
  }

  if (run.referenceType === 'hopinto') {
    return 'External link';
  }

  return run.referenceLabel || 'My drawn reaction';
}
